import React from 'react';
import NavBar from '../NavBar';
import Footer from '../Footer';
import '../../../styles/LegalPages.css';

const Privacy = () => {
  return (
    <div className="legal-page">
      <NavBar />

      <main className="legal-container">
        <section className="legal-hero">
          <span className="legal-badge">PRIVACY POLICY</span>

          <h1>
            Privacy <span>Policy</span>
          </h1>

          <p>
            Your privacy is important to us. This Privacy Policy explains
            how DEFilms handles information when you use our website.
          </p>
        </section>

        <section className="legal-content">

          <div className="legal-section">
            <h2>1. Introduction</h2>

            <p>
              Welcome to <strong>DEFilms</strong>. This Privacy Policy
              explains how information may be collected, used, and protected
              when you access or use
              <strong> https://defilms.online/</strong>.
            </p>

            <p>
              By using DEFilms, you acknowledge that you have read and
              understood this Privacy Policy.
            </p>
          </div>

          <div className="legal-section">
            <h2>2. Information We Collect</h2>

            <p>
              DEFilms may collect certain information automatically when you
              visit or use our website.
            </p>

            <p>This information may include:</p>

            <ul>
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Device type</li>
              <li>Operating system</li>
              <li>Pages visited</li>
              <li>Date and time of visits</li>
              <li>General website usage information</li>
              <li>Other technical information provided by your browser</li>
            </ul>

            <p>
              We do not intentionally collect personal information that is
              not necessary for operating and improving the website.
            </p>
          </div>

          <div className="legal-section">
            <h2>3. How We Use Information</h2>

            <p>
              Information collected through the website may be used for the
              following purposes:
            </p>

            <ul>
              <li>To operate and maintain DEFilms.</li>
              <li>To improve website performance and functionality.</li>
              <li>To understand how visitors use our website.</li>
              <li>To detect and prevent abuse or fraudulent activity.</li>
              <li>To improve the user experience.</li>
              <li>To provide relevant advertising when applicable.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>4. Cookies</h2>

            <p>
              DEFilms may use cookies and similar technologies to improve
              website functionality and user experience.
            </p>

            <p>
              Cookies may be used to remember preferences, analyze website
              traffic, improve services, and support advertising services.
            </p>

            <p>
              You can control or disable cookies through your browser
              settings. Disabling cookies may affect certain website
              features.
            </p>
          </div>

          <div className="legal-section">
            <h2>5. Google AdSense</h2>

            <p>
              DEFilms may use <strong>Google AdSense</strong> to display
              advertisements.
            </p>

            <p>
              Google and its advertising partners may use cookies or similar
              technologies to display advertisements based on a users visits
              to this website and other websites.
            </p>

            <p>
              Users may manage their advertising preferences through their
              Google account or browser settings.
            </p>
          </div>

          <div className="legal-section">
            <h2>6. Third-Party Services</h2>

            <p>
              DEFilms may use third-party services to provide certain
              functionality, including but not limited to:
            </p>

            <ul>
              <li>Movie and TV information APIs</li>
              <li>Analytics services</li>
              <li>Advertising services</li>
              <li>Hosting services</li>
              <li>Content delivery networks</li>
              <li>Embedded media services</li>
            </ul>

            <p>
              These third-party services may collect or process information
              according to their own privacy policies and terms of service.
            </p>
          </div>

          <div className="legal-section">
            <h2>7. Movie Data and Metadata</h2>

            <p>
              DEFilms may display movie-related information such as titles,
              descriptions, release dates, genres, cast information, ratings,
              posters, images, and other metadata.
            </p>

            <p>
              Some information may be provided through third-party APIs or
              data providers.
            </p>

            <p>
              DEFilms does not claim ownership of third-party movie data,
              trademarks, images, posters, or other copyrighted materials.
            </p>
          </div>

          <div className="legal-section">
            <h2>8. External Links</h2>

            <p>
              DEFilms may contain links to external websites or third-party
              services.
            </p>

            <p>
              We are not responsible for the privacy practices, security,
              content, or policies of external websites.
            </p>

            <p>
              We recommend reviewing the privacy policies of third-party
              websites before providing any personal information.
            </p>
          </div>

          <div className="legal-section">
            <h2>9. Data Security</h2>

            <p>
              We take reasonable measures to help protect information
              associated with the operation of DEFilms.
            </p>

            <p>
              However, no method of transmission over the Internet or
              electronic storage is completely secure. Therefore, we cannot
              guarantee absolute security.
            </p>
          </div>

          <div className="legal-section">
            <h2>10. Childrens Privacy</h2>

            <p>
              DEFilms does not knowingly collect personal information from
              children.
            </p>

            <p>
              If you believe that a child has provided personal information
              through our website, please contact us so that the information
              can be reviewed and handled appropriately.
            </p>
          </div>

          <div className="legal-section">
            <h2>11. Your Privacy Choices</h2>

            <p>
              Depending on your browser, device, and location, you may have
              options to manage cookies, advertising preferences, and certain
              privacy settings.
            </p>

            <p>
              You can also adjust your browser settings to limit certain
              forms of data collection.
            </p>
          </div>

          <div className="legal-section">
            <h2>12. Changes to This Privacy Policy</h2>

            <p>
              DEFilms may update this Privacy Policy from time to time to
              reflect changes to our services, technology, or applicable
              requirements.
            </p>

            <p>
              Any changes will be published on this page with an updated
              revision date.
            </p>
          </div>

          <div className="legal-section">
            <h2>13. Contact Us</h2>

            <p>
              If you have questions or concerns about this Privacy Policy,
              please contact the DEFilms team.
            </p>

            <a
              href="/contact"
              className="legal-contact-link"
            >
              Contact Us
            </a>
          </div>

          <div className="legal-contact-card">
            <h3>Your Privacy Matters</h3>

            <p>
              We value your privacy and aim to provide a safe and transparent
              experience while using DEFilms.
            </p>
          </div>

        </section>

        <div className="legal-updated">
          Last updated: September 21, 2026
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;